import type { User } from '@chicare/shared';

/**
 * Where this account belongs.
 *
 * `pharmacist` is a ChiCare STAFF role, not a pharmacy that sells here — it is
 * the clinician who reads reports that a medicine caused harm. It had no
 * console at all until that desk was built, and signed in successfully to
 * nowhere.
 */
export function homeForRole(role: User['role'] | undefined): string {
  switch (role) {
    case 'admin':
    case 'super_admin':
      return '/admin';
    case 'pharmacy':
      return '/seller';
    case 'rider':
      return '/rider';
    case 'pharmacist':
      // Inside the console, in the one room they may enter.
      return '/admin/clinical';
    default:
      return '/';
  }
}
